import { ResponseType, PaginationResponseType } from 'types/response.d';
import { RoleType } from 'types/entities/roles.d';
import { PermissionCriteria, RoleCriteria } from 'types/models/roles.d';
import { PermissionType } from 'types/entities/permissions.d';
import { get, post, put, axios } from './axios';

const url = `/roles`;

export const getById = (id: number): Promise<ResponseType<RoleType>> => get(`${url}/${id}`);

export const filter = (request: RoleCriteria): Promise<PaginationResponseType<RoleType[]>> =>
  get(url, { params: { ...request } });

export const update = (id: number, request: RoleType): Promise<ResponseType<RoleType>> =>
  put(`${url}/${id}`, request);

export const create = (request: RoleType): Promise<ResponseType<RoleType>> => post(url, request);

export const deleteById = (id: number): Promise<ResponseType<boolean>> =>
  axios.delete(`${url}/${id}`);

export const filterPermissions = (
  request: PermissionCriteria
): Promise<PaginationResponseType<PermissionType[]>> =>
  get(`${url}/permissions`, { params: { ...request } });
